// extracted by mini-css-extract-plugin
export default {"toolbar":"EditableSection_toolbar__6xnC7","addButtonSpacing":"EditableSection_addButtonSpacing__T20gV"};